/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ contact: NonNullable<unknown> }} Privacy_Rights_1Inputs */

const da_privacy_rights_1 = /** @type {(inputs: Privacy_Rights_1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du har ret til indsigt, berigtigelse, sletning, begrænsning, dataportabilitet og til at gøre indsigelse. Skriv til ${i?.contact}. Du kan selv slette alle dine data under Indstillinger → Konto og data.`)
};

/** @type {(inputs: Privacy_Rights_1Inputs) => LocalizedString} */
const en_privacy_rights_1 = da_privacy_rights_1;

/**

* @param {Privacy_Rights_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_1 = /** @type {((inputs: Privacy_Rights_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_rights_1(inputs)
	return da_privacy_rights_1(inputs)
});